const config = {
  api_base_url_stg: "https://backend.omdlive.com/api/",
  api_base_url_live: "https://backend.omdlive.com/api/",
};
export default config;



